import { useAgentFieldUpdateAgentFieldUpdatePostMutation } from '@shared/api';
import type { CreateAgentFieldValues } from '../lib/types';

export const useUpdateField = () => {
  const [updateFieldMutation, { isLoading }] = useAgentFieldUpdateAgentFieldUpdatePostMutation();

  const updateField = async (agentFieldId: number, values: CreateAgentFieldValues) => {
    try {
      const normalizedFilter = values.filter.map((item) => item.trim()).filter(Boolean);
      await updateFieldMutation({
        agentFieldId,
        updateAgentField: {
          name: values.name,
          description: values.description,
          filter: normalizedFilter,
          alias: values.alias,
          use_knowledge_filter: values.useKnowledgeFilter,
          is_required: values.isRequired,
          is_active: values.isActive,
        },
      }).unwrap();
    } catch (e) {}
  };

  return {
    updateField,
    isLoading,
  };
};
